module.exports = __webpack_public_path__ + "static/media/5 1 Leseforstaelse Intro.86cf3617.mp3";